import XcolumnFunc from "@/pcomponents/common/xcolumn/xcolumn/xcolumn_func";
//const xColumnArr=getXcolumnJson();

const getXcolumnJson=()=>{
  let initData:any={
    table:"desku",
    list_id:"desku_history_list",
    x_column_list_arr:[
      {"key":"row_view_room_name","name":"강의실","width":"90","is_show":"1"},
      {"key":"a_name","name":"책상","width":"70","is_show":"1"},
      {"key":"a_subject","name":"과목","width":"70","is_show":"1"},
      {"key":"a_user_name","name":"사용자","width":"70","is_show":"1"},
      {"key":"a_date","name":"사용일","width":"100","is_show":"1"},
      {"key":"row_view_start","name":"시작","width":"60","is_show":"1"},
      {"key":"row_view_end","name":"종료","width":"60","is_show":"1"},
      {"key":"row_view_period","name":"사용량(시:분)","width":"100","is_show":"1"},
      {"key":"a_is_target_time","name":"자동종료","width":"70","is_show":"1"},
      {"key":"a_create_date","name":"작성일","width":"180","is_show":""},
      {"key":"a_update_date","name":"수정일","width":"180","is_show":""},
    ],
    list_opt_origin:{
      'now_page':1,
      'num_per_page':100,
      'order_id':'a_create_date DESC',
      'order_type':'',
      's_date_type':'',
      's_start_date':'',
      's_end_date':'',
      'sc':{},
      "is_add_idx_info":"1",
      "s_class_seq":"",
      "s_school_name":"",
      "s_stu_grade":"",
      "s_stu_state":"now",
      "s_is_par_join":"",
      "s_search_text_type":"name",
      "s_search_text":"",
      "s_user_name_like":"",
      "s_phone_like":"",
      "s_stu_num_like":"",
      "s_school_name_like":"",
      "s_class_name_like":"",
    },
    order_id_col_arr:[
      {"value":"","text":"없음"},
    ]
  };
  initData.pri_col_arr=["a_ymd","a_seq"];
  const xColumnArr:any=XcolumnFunc.getDefaultXcolumn(initData);
  xColumnArr.date_col_arr=["a_date"];

  return xColumnArr;
};

export default getXcolumnJson;